import { httpRequest } from "../../http";

export class CommandDeleteAd {
  async run(adId: number) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${adId}/`;
    try {
      const response = await httpRequest<any>(url, { method: "DELETE" });
      if (response) {
        return response;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }
}
